import { render, staticRenderFns } from "./contract-extra-info.vue?vue&type=template&id=1676dd0b&scoped=true"
import script from "./contract-extra-info.vue?vue&type=script&setup=true&lang=js"
export * from "./contract-extra-info.vue?vue&type=script&setup=true&lang=js"
import style0 from "./contract-extra-info.vue?vue&type=style&index=0&id=1676dd0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676dd0b",
  null
  
)

export default component.exports